import { api } from "@/lib/api";

const FALLBACK = {
  name: "",
  currency: "USD",
  number_format: "en-US",
  measurement: "imperial",
  hours: { start: "08:00", end: "17:00", timezone: "America/Chicago" },
};

const SYMBOLS = {
  USD: "$",
  CAD: "$",
  AUD: "$",
  EUR: "€",
  GBP: "£",
  BAM: "KM",
};

let config = FALLBACK;
let pending = null;

export const companySymbol = () => SYMBOLS[config.currency] || "$";
export const companyLocale = () => config.number_format || "en-US";
export const companyConfig = () => config;

/** Loaded once per session; printouts and money() read the cached copy. */
export const loadCompany = () => {
  if (!pending) {
    pending = api
      .get("/settings/company")
      .then(({ data }) => {
        config = { ...FALLBACK, ...data };
        return config;
      })
      .catch(() => config);
  }
  return pending;
};

export const refreshCompany = (next) => {
  config = { ...FALLBACK, ...next };
  pending = Promise.resolve(config);
};
